import colors from '@/game/vars/colors';
import layout from '@/game/vars/layout';
import levels from '@/game/vars/levels';

export default {
  colors,
  layout,
  levels,
};
